var map = {
	"./biology.json": [
		"41Tg",
		67
	],
	"./carousel.json": [
		"W0Q0",
		9
	],
	"./chemistry.json": [
		"MNbi",
		66
	],
	"./computer.json": [
		"LAX/",
		65
	],
	"./directors.json": [
		"RH1C",
		8
	],
	"./dormStaff.json": [
		"46qI",
		64
	],
	"./engineering.json": [
		"3G8M",
		63
	],
	"./english.json": [
		"hVcZ",
		62
	],
	"./health.json": [
		"bzVg",
		61
	],
	"./history.json": [
		"F1Rq",
		60
	],
	"./index.json": [
		"hADh",
		7
	],
	"./maths.json": [
		"GcX/",
		59
	],
	"./modal.json": [
		"76Tf",
		6
	],
	"./officers.json": [
		"jOUd",
		58
	],
	"./physics.json": [
		"LxqP",
		57
	],
	"./psychologist.json": [
		"x432",
		56
	],
	"./staff.json": [
		"av2I",
		5
	],
	"./thai.json": [
		"COUR",
		55
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "u2aI";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/json/en/staff lazy ^\.\/.*\.json$
// module id = u2aI
// module chunks = 81